import React, { FC } from "react";
import { useSelector } from "react-redux";

import { Label } from "./styled";

import { getMouseLabel } from "../../ducks/mouseLabel/selectors";
import { useMousePosition } from "../../hooks/useMousePosition";
import { defaultOffset } from "../../react-sgis/symbols/labelSymbols/labelSymbols";

export const MouseLabel: FC = () => {
  const text = useSelector(getMouseLabel);
  const position = useMousePosition();

  return text ? (
    <Label style={{ left: position.x + defaultOffset[0], top: position.y + defaultOffset[1] }}>{text}</Label>
  ) : null;
};
